// Define the base Persistence interface to match Firebase auth expectations
export interface IPersistence {
  readonly type: "SESSION" | "LOCAL" | "NONE" | "COOKIE";
}

export type Persistence = IPersistence;

export const enum PersistenceType {
  SESSION = "SESSION",
  LOCAL = "LOCAL",
  NONE = "NONE",
  COOKIE = "COOKIE",
}

export type PersistedBlob = Record<string, unknown>;
export type PersistenceValue = PersistedBlob | string;
export const STORAGE_AVAILABLE_KEY = "__sak";

export interface IStorageEventListener {
  (value: PersistenceValue | null): void;
}

export type StorageEventListener = IStorageEventListener;

export interface IPersistenceInternal extends IPersistence {
  type: PersistenceType;
  _isAvailable(): Promise<boolean>;
  _set(key: string, value: PersistenceValue): Promise<void>;
  _get<T extends PersistenceValue>(key: string): Promise<T | null>;
  _remove(key: string): Promise<void>;
  _addListener(key: string, listener: IStorageEventListener): void;
  _removeListener(key: string, listener: IStorageEventListener): void;
  _shouldAllowMigration?: boolean;
}

export type PersistenceInternal = IPersistenceInternal;
